import { LISTAR_URAS, LISTAR_URA_SELECIONADA, LISTAR_ROTAS, LISTAR_AUDIOS, GET_URA_USE, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

import UrasHttpService from '../_services/UrasHttpService'

export default {
  listarUras: async ({ commit }) => {
    try {
      const response = await UrasHttpService.getUras()
      commit(LISTAR_URAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  selecionarUra: async ({ commit }, id) => {
    try {
      const response = await UrasHttpService.getUra(id)
      commit(LISTAR_URA_SELECIONADA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarUraUse: async ({ commit }, id) => {
    try {
      const response = await UrasHttpService.getUraUse(id)
      commit(GET_URA_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRotas: async ({ commit }) => {
    try {
      const response = await UrasHttpService.getrotas()
      commit(LISTAR_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarAudios: async ({ commit }) => {
    try {
      const response = await UrasHttpService.getAudios()
      commit(LISTAR_AUDIOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposDeRotas: async ({ commit }) => {
    try{
      const response = await UrasHttpService.getGruposDeRotas()
      commit(LISTAR_GRUPOS_DE_ROTAS, response.data)
    }catch(e) {
      console.log(e)
    }
  }
}
